export class SkyLinkRecordsMatchesSetItemAction {
  constructor(
    public key: string,
    public item: any
  ) {}
}
